import { MultiBarGraphProps } from './type';
import Typography from '../Typography';
import { formatNumberAsCurrency, getUniqueKey } from '../utils';
import {
  WrapMultiBarGraphStyle,
  WrapMultiLabelStyle,
  WrapMultiBarStyle,
  MultiBarStyle,
  BackgroundMultiBarStyle,
} from './styled';

const MultiBarGraph = ({ ...props }: MultiBarGraphProps) => {
  const { step, total, data, barWidth, gap, initialLabelType, finalLabelType, colors } = props;

  return (
    <WrapMultiBarGraphStyle {...props}>
      <WrapMultiLabelStyle {...props}>
        {Array.from(Array(step + 1), (_, index) => index)
          .reverse()
          .map((elem) => (
            <Typography
              key={getUniqueKey()}
              color="#5B5D71"
              style={{
                fontSize: '10px',
                fontWeight: 500,
                textAlign: 'right',
              }}
            >
              {initialLabelType || ''}
              {formatNumberAsCurrency(Math.round(total * (elem / step)))}
              {finalLabelType || ''}
            </Typography>
          ))}
      </WrapMultiLabelStyle>
      <div
        style={{
          display: 'flex',
          gap,
          padding: '0px 40px 40px 0px',
        }}
      >
        {data.map(({ values, label, title }, index) => {
          return (
            <WrapMultiBarStyle key={getUniqueKey()} label={label} title={title}>
              {values.map((value, barIndex) => {
                return (
                  <BackgroundMultiBarStyle key={getUniqueKey()} data-testid={`bar-${index}`}>
                    <MultiBarStyle
                      color={colors && colors.length > barIndex ? colors[barIndex] : null}
                      graphValue={(value * 100) / total}
                      size={barWidth}
                    />
                  </BackgroundMultiBarStyle>
                );
              })}
            </WrapMultiBarStyle>
          );
        })}
      </div>
    </WrapMultiBarGraphStyle>
  );
};

MultiBarGraph.defaultProps = {
  data: [],
  step: 5,
  total: 0,
  barWidth: '12px',
  gap: '20px',
  labelType: '',
  maxWidth: '100%',
  maxHeight: '300px',
};
export default MultiBarGraph;
